import React from 'react'

const Header = () => {
  return (
    <div className='header'>
      <h1>MyTask</h1>
    </div>
  )
}

export default Header
